'use client'
import { CommonContent, Faqs, Policy } from '@/features/help'
import { LIST_TYPE, TContentByKey, TNewCovertData } from '../types'
import { parseSafe } from '../utils/parseSafe'

export const HelpContainer = ({ data }: { data: TContentByKey[]; detail: string }) => {
  const tempData =
    data?.map((item) => parseSafe(item?.json || `{type: ${LIST_TYPE.COMMON},items: {}}`)) ||
    ([{ type: LIST_TYPE.COMMON, items: {} }] as TNewCovertData[])
  const convertedData = [...(tempData || ([] as any))]
  if (!data || data?.length === 0) {
    return <CommonContent data={undefined} isLoading={false} />
  }

  return (
    <>
      {convertedData?.map((item, index) => {
        if (item?.type === LIST_TYPE.COMMON) {
          return <CommonContent key={index} data={item.items} />
        }
        if (item?.type === LIST_TYPE.LIST) {
          return <Policy key={index} data={item.items} />
        }

        if (item?.type === LIST_TYPE.COLLAPSE) {
          return <Faqs key={index} data={item.items} />
        }
        return <CommonContent data={undefined} isLoading={false} key={index} />
      })}
    </>
  )
}
